module.exports = __webpack_public_path__ + "img/202003.822e68fd.png";